<div class="column content-container">
	<mat-form-field
		subscriptSizing="dynamic"
		class="column-double device-search-field placeholder-text-style"
		style="margin-bottom: 0px"
		appearance="outline"
	>
		<input
			matInput
			#filterInput
			[matAutocomplete]="auto"
			[matAutocompletePosition]="'below'"
			(keyup)="deviceLookupEvents.next(filterInput.value)"
			[attr.data-automation-id]="'device-search-input-' + searchType"
			[placeholder]="searchPlaceholder + ' ' + searchByOptions[searchType]"
		/>
		<mat-icon matPrefix svgIcon="sl-search"></mat-icon>
		<mat-autocomplete
			#auto="matAutocomplete"
			[displayWith]="displayFn"
			data-automation-id="device-search-picker"
			class="device-search-autocomplete"
		>
			@for (
				item of deviceSearchResults | async;
				track item.device?.id ?? item.device?.serialNumber ?? item;
				let idx = $index
			) {
				<mat-option
					class="generate-code-device-lookup-option-container"
					[value]="item"
					(click)="onDeviceSelected(item)"
					[attr.data-automation-id]="'search-results-' + idx"
				>
					<div class="float-container">
						<div class="float-left" [class.full-width]="!item?.device && !item?.serialNumber">
							{{ displayDeviceSearchItemSerialNumber(item) }}
						</div>
						@if (item?.device || item?.serialNumber) {
							<div class="float-right">
								<div class="device-search-item-property-name">{{ displayDeviceSearchItemPropertyName(item) }}</div>
								<div class="device-search-item-device-location">{{ displayDeviceSearchItemDeviceLocation(item) }}</div>
							</div>
						}
					</div>
				</mat-option>
			}
		</mat-autocomplete>
	</mat-form-field>
</div>
